import AIVisibilityCompetitorTable from './AIVisibilityCompetitorTable';
import AIVisibilityCompetitorTrendChart from './AIVisibilityCompetitorTrendChart';
import AIVisibilityInsightsSummary from './AIVisibilityInsightsSummary';
import AIVisibilityProductAreaTable from './AIVisibilityProductAreaTable';

const AIVisibilityCompetitors = () => (
  <div className="flex flex-col gap-6 pt-6">
    <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)]">
      <AIVisibilityInsightsSummary />
      <AIVisibilityCompetitorTrendChart />
    </div>
    <AIVisibilityCompetitorTable />
    <AIVisibilityProductAreaTable />
  </div>
);

export default AIVisibilityCompetitors;
